import { Text } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import { FlipperFlagCondition } from '@spa/features'
import { FieldTimeRange, FieldTimeRangeLegacy } from '@spa/features/Scheduling'
import type { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

type Props = {
  disabled: boolean
}
export const HourFields: FC<Props> = ({ disabled }) => {
  const { t } = usePlanningFormTranslation()

  const {
    control,
    formState: { errors }
  } = useFormContext()

  return (
    <div className='mb-4'>
      <Text size='information' className='mb-2 font-medium text-neutral-800'>
        {t('restForm.restDuration')}
      </Text>
      <Controller
        name='time_range'
        control={control}
        render={({ field: { value, onChange } }) => {
          return (
            <FlipperFlagCondition
              flag='frontend_scheduling_enable_new_timeinput'
              active={
                <FieldTimeRange
                  prefixLabels={[
                    t('component.fieldTimeRange.from'),
                    t('component.fieldTimeRange.to')
                  ]}
                  startEl={{
                    autoFocus: true
                  }}
                  error={formatErrors({
                    inputName: 'time_range',
                    errors
                  })}
                  values={value}
                  onChange={onChange}
                  disabled={disabled}
                  inputId='time_range'
                />
              }
              inactive={
                <FieldTimeRangeLegacy
                  prefixLabels={[
                    t('component.fieldTimeRange.from'),
                    t('component.fieldTimeRange.to')
                  ]}
                  placeholders={['__:__', '__:__']}
                  startEl={{
                    inputProps: {
                      autoFocus: true
                    }
                  }}
                  error={formatErrors({
                    inputName: 'time_range',
                    errors
                  })}
                  values={value}
                  onChange={onChange}
                  disabled={disabled}
                  inputId='time_range'
                />
              }
            />
          )
        }}
      />
    </div>
  )
}
